(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atomico-franja-promociones"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atomico-promo-marquee')) {
  customElements.define('atomico-promo-marquee', class extends HTMLElement {
    connectedCallback() {
      this.prepare();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
    async prepare() {
      await document.fonts.ready;
      if (!this.isConnected || this.classList.contains('is-ready')) return;
      const viewport = this.querySelector('.atomico-cinta__ventana');
      const group = this.querySelector('.atomico-cinta__grupo');
      const duration = parseFloat(getComputedStyle(this).getPropertyValue('--cinta-tiempo')) || 45;
      const headline = group.querySelector('.atomico-cinta__mensaje--msi > span');
      const textOffset = headline.getBoundingClientRect().left - group.getBoundingClientRect().left;
      const distance = Math.max(0, viewport.clientWidth * 0.8 - textOffset);
      this.style.setProperty('--cinta-inicio', distance + 'px');
      this.style.setProperty('--cinta-entrada', Math.max(0.1, duration * distance / group.getBoundingClientRect().width) + 's');
      this.observer?.disconnect();
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.classList.add('is-ready');
          this.observer.disconnect();
        }
      }, {threshold: 0.1});
      this.observer.observe(this);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atomico-newsletter"]) return;
  try {
    
if (!customElements.get('atomico-newsletter')) {
  customElements.define('atomico-newsletter', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.tab = this.querySelector('.an-tab');
      this.form = this.querySelector('form');
      this.status = this.querySelector('.an-status');
      this.key = 'atomico-newsletter-v1';
      this.state = this.readState();
      this.events = new AbortController();
      const opts = { signal: this.events.signal };
      this.querySelector('.an-close').addEventListener('click', () => this.dialog.close(), opts);
      this.dialog.addEventListener('click', e => { if (e.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if(e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.dialog.close(); } }, opts);
      this.dialog.addEventListener('close', () => {
  if (!this.state.subscribed && this.dataset.preview !== 'true') {
    this.state.closeCount = (Number(this.state.closeCount) || 0) + 1;

    if (this.state.closeCount >= 2) {
      this.state.hideUntil = Date.now() + 86400000;
    }

    this.saveState();
  }

  this.tab.hidden = Boolean(this.state.subscribed) || this.isSnoozed();

  if (this.returnFocus?.isConnected && this.returnFocus !== this.tab) {
    this.returnFocus.focus({ preventScroll: true });
  }
}, opts);
      this.tab.addEventListener('click', () => this.open(), opts);
      this.form.addEventListener('submit', e => this.submit(e), opts);
      this.querySelector('.an-copy').addEventListener('click', () => this.copy(), opts);
      this.onScroll = () => { if (this.frame) return; this.frame = requestAnimationFrame(() => { this.frame = 0; this.maybeOpen(); }); };
      window.addEventListener('scroll', this.onScroll, { passive: true, signal: this.events.signal });
      window.addEventListener('resize', this.onScroll, opts);
      this.tab.hidden = Boolean(this.state.subscribed) || this.isSnoozed() || (!this.state.lastShown && this.dataset.preview !== 'true');
      if (this.state.subscribed) this.showSuccess(false);
      this.onScroll();
    }
    readState() { try { return JSON.parse(localStorage.getItem(this.key) || '{}') || {}; } catch { return {}; } }
    saveState() { try { localStorage.setItem(this.key, JSON.stringify(this.state)); } catch {} }
    isSnoozed() {
  const until = Number(this.state.hideUntil) || 0;

  if (until > Date.now()) return true;

  if (until) {
    this.state.closeCount = 0;
    delete this.state.hideUntil;
    this.saveState();
  }

  return false;
}

blocked() {
  return this.isSnoozed() || Boolean(
    document.querySelector('#drawer-cart.drawer--visible, dialog[open]')
  );
}
    maybeOpen() {
      if (this.dataset.preview === 'true' || this.state.subscribed || this.blocked()) return;
      if (Date.now() - (Number(this.state.lastShown) || 0) < 86400000) return;
      const available = document.documentElement.scrollHeight - window.innerHeight;
      if (available > 0 && window.scrollY / available >= .4) this.open();
    }
    open() {
      if (this.blocked()) return;
      this.returnFocus = document.activeElement;
      this.dialog.showModal();
      this.tab.hidden = true;
      this.state.lastShown = Date.now();
      this.saveState();
    }
    submit(event) {
      event.preventDefault();
      if (this.pending || !this.form.reportValidity()) return;
      const data = new FormData(this.form);
      if (data.get('b_99a5f5785fe552dc23e76649f_f4da069862')) return;
      this.pending = true;
      const submit = this.form.querySelector('[type=submit]');
      submit.disabled = true;
      this.status.textContent = this.dataset.busy;
      this.querySelector('.an-fallback').hidden = true;
      const name = 'atomicoSubscribe' + Date.now() + Math.floor(Math.random() * 100000);
      const script = document.createElement('script');
      const url = new URL(this.form.action);
      url.pathname = url.pathname.replace('/post', '/post-json');
      url.searchParams.set('EMAIL', String(data.get('EMAIL')).trim());
      url.searchParams.set('b_99a5f5785fe552dc23e76649f_f4da069862', '');
      url.searchParams.set('c', name);
      let finished = false;
      const finish = response => {
        if (finished) return;
        finished = true;
        clearTimeout(timer);
        script.remove();
        window[name] = () => {};
        setTimeout(() => { delete window[name]; }, 60000);
        this.pending = false;
        submit.disabled = false;
        this.cancelRequest = null;
        if (!this.isConnected) return;
        if (response?.result === 'success') {
          this.state.subscribed = true;
          this.saveState();
          this.showSuccess(true);
        } else {
          const message = typeof response?.msg === 'string' ? new DOMParser().parseFromString(response.msg, 'text/html').body.textContent : '';
          this.status.textContent = message || this.dataset.error;
          this.querySelector('.an-fallback').hidden = false;
        }
      };
      const timer = setTimeout(() => finish(null), 20000);
      this.cancelRequest = () => finish(null);
      window[name] = finish;
      script.onerror = () => finish(null);
      script.src = url.href;
      document.head.appendChild(script);
    }
    showSuccess(focus) {
      this.querySelector('.an-signup').hidden = true;
      const success = this.querySelector('.an-success');
      success.hidden = false;
      const heading = success.querySelector('h2');
      heading.id = 'an-success-' + this.dataset.section;
      this.dialog.setAttribute('aria-labelledby', heading.id);
      if (focus && this.dialog.open) heading.focus();
    }
    async copy() {
      const code = this.querySelector('.an-code');
      try { await navigator.clipboard.writeText(code.textContent.trim()); this.querySelector('.an-copy-status').textContent = this.dataset.copied; }
      catch { const range = document.createRange(); range.selectNodeContents(code); const selection = window.getSelection(); selection.removeAllRanges(); selection.addRange(range); }
    }
    disconnectedCallback() { this.events?.abort(); cancelAnimationFrame(this.frame); this.cancelRequest?.(); if (this.dialog?.open) this.dialog.close(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  if (!customElements.get('atomico-collection')) {
    customElements.define('atomico-collection', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.opener = this.querySelector('[data-ac-open]');
        this.media = window.matchMedia('(max-width: 767px)');
        this.denseMedia = window.matchMedia('(min-width: 990px)');
        this.syncDensity = () => {
          let density = 'compact';
          try { density = sessionStorage.getItem('atomico-collection-' + (this.media.matches ? 'mobile' : 'desktop')) || density; } catch (_) {}
          this.setDensity(density);
        };
        this.syncDensity();
        this.media.addEventListener('change', this.syncDensity, options);
        this.denseMedia.addEventListener('change', this.syncDensity, options);
        this.addEventListener('click', (event) => {
          const densityButton = event.target.closest('[data-ac-density]');
          if (densityButton) {
            this.setDensity(densityButton.dataset.acDensity);
            try { sessionStorage.setItem('atomico-collection-' + (this.media.matches ? 'mobile' : 'desktop'), this.dataset.density); } catch (_) {}
          }
          if (event.target.closest('[data-ac-open]') && this.dialog) {
            this.dialog.showModal();
            this.opener.setAttribute('aria-expanded', 'true');
          }
          if (event.target.closest('[data-ac-close]')) this.dialog.close();
          if (event.target === this.dialog) {
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
          }
        }, options);
        this.dialog?.addEventListener('close', () => {
          this.opener.setAttribute('aria-expanded', 'false');
          this.opener.focus({ preventScroll: true });
        }, options);
        this.querySelector('[data-ac-sort]')?.addEventListener('change', (event) => {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', event.target.value);
          url.searchParams.delete('page');
          window.location.assign(url.href);
        }, options);
        this.querySelector('[data-ac-form]')?.addEventListener('submit', (event) => {
          const form = event.currentTarget;
          const min = form.querySelector('[data-ac-min]');
          const max = form.querySelector('[data-ac-max]');
          if (min?.value && max?.value && Number(min.value) > Number(max.value)) {
            const value = min.value; min.value = max.value; max.value = value;
          }
          form.querySelectorAll('input[type="number"]').forEach(input => { if (input.value === '') input.disabled = true; });
        }, options);
      }
      setDensity(density) {
        this.dataset.density = density === 'dense' && this.denseMedia.matches ? 'dense' : density === 'spacious' ? 'spacious' : 'compact';
        this.querySelectorAll('[data-ac-density]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.acDensity === this.dataset.density)));
        window.dispatchEvent(new Event('resize'));
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["facturacion-atomico"] && !Shopify.designMode) return;
  try {
    
/* Normaliza el RFC real enviado, además de mostrarlo en mayúsculas.
   La comprobación de formato no valida su registro ante el SAT. */
document.addEventListener('input', (event) => {
  if (event.target.matches('.atomico-invoice [data-invoice-rfc]')) {
    const field = event.target;
    const start = field.selectionStart;
    const end = field.selectionEnd;
    field.value = field.value.toUpperCase();
    if (start !== null && end !== null) field.setSelectionRange(start, end);
  }
});

/* Muestra usos compatibles con el régimen seleccionado.
   CP01 y CN01 permanecen deshabilitados: son para pagos y nómina.
   Si cambia el régimen, borra un uso que ya no sea compatible. */
function atomicoUpdateInvoiceUses(form) {
  const regimen = form.querySelector('[data-invoice-regimen]');
  const uso = form.querySelector('[data-invoice-uso]');
  if (!regimen || !uso) return;
  const code = regimen.selectedOptions[0]?.dataset.code || '';
  const oldValue = uso.value;
  for (const option of uso.options) {
    if (!option.value) continue;
    const compatible = !code || option.dataset.regimes.split(',').includes(code);
    option.hidden = !compatible;
    option.disabled = !compatible || option.dataset.special === 'true';
  }
  const selected = [...uso.options].find(option => option.value === oldValue);
  if (!code || (selected && selected.disabled)) uso.value = '';
  uso.disabled = !code;
}
function atomicoInitInvoiceMenus(root) {
  root.querySelectorAll('.atomico-invoice form').forEach(atomicoUpdateInvoiceUses);
}
document.addEventListener('change', (event) => {
  if (event.target.matches('.atomico-invoice [data-invoice-regimen]')) {
    atomicoUpdateInvoiceUses(event.target.form);
  }
});
document.addEventListener('shopify:section:load', (event) => {
  atomicoInitInvoiceMenus(event.target);
});
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => atomicoInitInvoiceMenus(document), { once: true });
} else {
  atomicoInitInvoiceMenus(document);
}


/* Conserva un solo # al inicio y permite números, letras y espacios. */
function atomicoOrderValue(value) {
  return '#' + value.replace(/#/g, '').replace(/[\r\n]/g, ' ');
}
/* Limpia importes; admite punto decimal y hasta dos decimales.
   Al pegar $1,899.99 elimina la coma de miles.
   También acepta 1899,99 como importe decimal. */
function atomicoMoneyValue(value, complete) {
  if (value.includes('-')) return '$';
  let amount = value.replace(/[^0-9.,]/g, '');
  if (!amount.includes('.') && /^[0-9]+,[0-9]{1,2}$/.test(amount)) {
    amount = amount.replace(',', '.');
  } else {
    amount = amount.replace(/,/g, '');
  }
  const parts = amount.split('.');
  let integer = parts[0].replace(/^0+(?=[0-9])/, '');
  let decimals = parts.slice(1).join('').slice(0, 2);
  if (!integer && parts.length > 1) integer = '0';
  if (!integer) return '$';
  if (complete) return '$' + integer + '.' + decimals.padEnd(2, '0');
  return '$' + integer + (parts.length > 1 ? '.' + decimals : '');
}
function atomicoFormatInvoiceField(field, complete = false) {
  const money = field.matches('[data-invoice-money]');
  const start = field.selectionStart;
  const before = start === null ? field.value : field.value.slice(0, start);
  field.value = money
    ? atomicoMoneyValue(field.value, complete)
    : atomicoOrderValue(field.value);
  if (money) {
    const nonZero = /[1-9]/.test(field.value);
    field.setCustomValidity(field.value === '$' || nonZero ? '' : 'Escribe un importe mayor que $0.00.');
  }
  if (!complete && start !== null) {
    const cleanedBefore = money ? atomicoMoneyValue(before, false) : atomicoOrderValue(before);
    const caret = Math.min(field.value.length, Math.max(1, cleanedBefore.length));
    field.setSelectionRange(caret, caret);
  }
}
document.addEventListener('input', (event) => {
  if (event.target.matches('.atomico-invoice [data-invoice-order], .atomico-invoice [data-invoice-money]')) {
    atomicoFormatInvoiceField(event.target);
  }
});
/* Añade .00 al salir del importe; mantiene el prefijo al borrar. */
document.addEventListener('focusout', (event) => {
  if (event.target.matches('.atomico-invoice [data-invoice-money]')) {
    atomicoFormatInvoiceField(event.target, true);
  }
});
document.addEventListener('keydown', (event) => {
  const field = event.target;
  if (!field.matches('.atomico-invoice [data-invoice-order], .atomico-invoice [data-invoice-money]')) return;
  if (event.key === 'Backspace' && field.selectionStart <= 1 && field.selectionEnd <= 1) event.preventDefault();
});
/* Asegura el formato enviado, incluso si no se salió del campo. */
document.addEventListener('submit', (event) => {
  if (!event.target.matches('.atomico-invoice form')) return;
  event.target.querySelectorAll('[data-invoice-order], [data-invoice-money]').forEach(field => {
    atomicoFormatInvoiceField(field, field.matches('[data-invoice-money]'));
  });
  if (!event.target.reportValidity()) event.preventDefault();
}, true);
function atomicoInitInvoicePrefixes(root) {
  root.querySelectorAll('.atomico-invoice [data-invoice-order], .atomico-invoice [data-invoice-money]').forEach(field => {
    atomicoFormatInvoiceField(field, field.matches('[data-invoice-money]') && field.value !== '$');
  });
}
document.addEventListener('shopify:section:load', event => atomicoInitInvoicePrefixes(event.target));
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => atomicoInitInvoicePrefixes(document), { once: true });
} else {
  atomicoInitInvoicePrefixes(document);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('atomico-footer-navigation')) {
    customElements.define('atomico-footer-navigation', class extends HTMLElement {
      connectedCallback() {
        this.media = window.matchMedia('(max-width: 767px)');
        this.groups = Array.from(this.querySelectorAll('details'));
        this.sync = () => this.groups.forEach(group => {
          group.open = !this.media.matches;
          group.querySelector('summary').tabIndex = this.media.matches ? 0 : -1;
        });
        this.onClick = event => {
          if (!this.media.matches && event.target.closest('summary')) event.preventDefault();
        };
        this.sync();
        this.media.addEventListener('change', this.sync);
        this.addEventListener('click', this.onClick);
      }
      disconnectedCallback() {
        this.media.removeEventListener('change', this.sync);
        this.removeEventListener('click', this.onClick);
      }
    });
  }

  if (!customElements.get('atomico-footer-newsletter')) {
    customElements.define('atomico-footer-newsletter', class extends HTMLElement {
      connectedCallback() {
        if (this.onSubmit) return;
        this.form = this.querySelector('form');
        this.status = this.querySelector('[data-newsletter-status]');
        this.success = this.querySelector('template[data-newsletter-success]');
        this.button = this.form?.querySelector('[type="submit"]');
        this.email = this.form?.querySelector('[name="EMAIL"]');
        if (!this.form || !this.status || !this.success || !this.button || !this.email) return;
        this.originalLabel = this.button.textContent;
        this.onSubmit = event => {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.pending || !this.form.reportValidity()) return;
          this.submitEmail();
        };
        this.form.addEventListener('submit', this.onSubmit, true);
      }
      submitEmail() {
        this.pending = true;
        this.status.replaceChildren();
        this.form.setAttribute('aria-busy', 'true');
        this.button.disabled = true;
        this.button.textContent = this.dataset.sending;
        this.email.readOnly = true;
        const url = new URL(this.form.action);
        url.pathname = url.pathname.replace('/post', '/post-json');
        new FormData(this.form).forEach((value, key) => url.searchParams.set(key, value));
        const callback = 'atomicoNewsletter_' + crypto.randomUUID().replaceAll('-', '');
        this.callback = callback;
        url.searchParams.set('c', callback);
        window[callback] = response => {
          if (!this.pending) return;
          const message = new DOMParser().parseFromString(String(response?.msg || ''), 'text/html').body.textContent.trim();
          if (response?.result === 'success') {
            if (/confirm|confirmation/i.test(message)) this.showMessage(this.dataset.confirmation);
            else this.status.replaceChildren(this.success.content.cloneNode(true));
            this.email.value = '';
          } else if (response?.msg === 'captcha' && response.params) {
            const verification = new URL(this.form.action);
            Object.entries(response.params).forEach(([key, value]) => verification.searchParams.set(key, String(value)));
            const paragraph = document.createElement('p');
            paragraph.textContent = this.dataset.verification + ' ';
            const link = document.createElement('a');
            link.href = verification.href;
            link.target = '_blank';
            link.rel = 'noopener';
            link.textContent = this.dataset.continue;
            paragraph.append(link);
            this.status.replaceChildren(paragraph);
          } else if (/already subscribed|ya est[aá] suscrit/i.test(message)) {
            this.showMessage(this.dataset.duplicate);
          } else {
            this.showMessage(message.replace(/^\d+\s*-\s*/, '') || this.dataset.error);
          }
          this.finish();
        };
        this.script = document.createElement('script');
        this.script.src = url.href;
        this.script.onerror = () => this.fail();
        this.timeout = window.setTimeout(() => this.fail(), 30000);
        document.head.append(this.script);
      }
      showMessage(message) {
        const paragraph = document.createElement('p');
        paragraph.textContent = message;
        this.status.replaceChildren(paragraph);
      }
      fail() {
        if (!this.pending) return;
        this.showMessage(this.dataset.error);
        this.finish();
      }
      finish() {
        window.clearTimeout(this.timeout);
        this.script?.remove();
        if (this.callback) {
          const callback = this.callback;
          window[callback] = () => {};
          window.setTimeout(() => { delete window[callback]; }, 60000);
        }
        this.pending = false;
        this.form.removeAttribute('aria-busy');
        this.button.disabled = false;
        this.button.textContent = this.originalLabel;
        this.email.readOnly = false;
      }
      disconnectedCallback() {
        if (this.pending) this.finish();
        this.form?.removeEventListener('submit', this.onSubmit, true);
        this.onSubmit = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
if (!customElements.get('atomico-header-motion')) {
  customElements.define('atomico-header-motion', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      this.header = this.querySelector('[data-header-height]');
      if (!this.header) return;
      this.classList.add('js__header__stuck');
      this.setAttribute('data-motion-initializing', '');
      this.measure();
      this.lastY = this.position();
      this.anchorY = this.lastY;
      this.direction = 0;
      this.toggleAttribute('data-motion-hidden', this.lastY > this.height);
      this.toggleAttribute('data-motion-announcement-hidden', this.lastY > this.announcementThreshold());
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.header);
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      };
      window.addEventListener('scroll', this.schedule, {...options, passive: true});
      window.addEventListener('pageshow', () => {
        this.measure();
        this.lastY = this.position();
        this.anchorY = this.lastY;
        this.direction = 0;
        this.toggleAttribute('data-motion-announcement-hidden', this.lastY > this.announcementThreshold());
        if (this.lastY <= 12) this.removeAttribute('data-motion-hidden');
      }, options);
      window.addEventListener('theme:scroll:lock', () => this.show(), options);
      this.addEventListener('focusin', event => {
        if (this.header.contains(event.target) && event.target.matches(':focus-visible')) this.show();
      }, options);
      this.readyFrame = requestAnimationFrame(() => this.removeAttribute('data-motion-initializing'));
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.readyFrame);
    }
    position() {
      return Math.max(0, Math.min(window.scrollY, document.documentElement.scrollHeight - window.innerHeight));
    }
    announcementThreshold() {
      return Math.max(50, (document.documentElement.scrollHeight - window.innerHeight) * 0.25);
    }
    measure() {
      const announcement = this.header.querySelector('atomico-announcement');
      const announcementHeight = announcement ? announcement.getBoundingClientRect().height : 0;
      if (announcementHeight !== this.announcementHeight) {
        this.announcementHeight = announcementHeight;
        this.style.setProperty('--atomico-announcement-height', announcementHeight + 'px');
      }
      const height = Math.ceil(this.header.getBoundingClientRect().height);
      if (!height || height === this.height) return;
      this.height = height;
      document.documentElement.style.setProperty('--menu-height', height + 'px');
      document.documentElement.style.setProperty('--header-height', height + 'px');
    }
    show() {
      this.removeAttribute('data-motion-hidden');
      this.anchorY = this.position();
      this.lastY = this.anchorY;
      this.direction = 0;
    }
    update() {
      const y = this.position();
      this.toggleAttribute('data-motion-announcement-hidden', y > this.announcementThreshold());
      if (document.documentElement.hasAttribute('data-scroll-locked') ||
          this.classList.contains('meganav--visible') ||
          this.header.querySelector(':focus-visible')) {
        this.show();
        return;
      }
      const delta = y - this.lastY;
      if (!delta) return;
      const direction = Math.sign(delta);
      if (direction !== this.direction) {
        this.anchorY = this.lastY;
        this.direction = direction;
      }
      this.lastY = y;
      if (y <= 12) {
        this.removeAttribute('data-motion-hidden');
        this.anchorY = y;
        return;
      }
      if (Math.abs(y - this.anchorY) < 50) return;
      if (direction > 0 && y > this.height) this.setAttribute('data-motion-hidden', '');
      else if (direction < 0) this.removeAttribute('data-motion-hidden');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lote-sorpresa"] && !Shopify.designMode) return;
  try {
    

function abrirDescripcionLote(root) {
  if (root.dataset.descripcionInicializada) return;
  root.dataset.descripcionInicializada = '1';

  const observer = new MutationObserver(abrir);

  function abrir() {
    const tab = root.querySelector(
      '.station-tabs-tab[data-slug="descripcion"]'
    );

    if (!tab) return false;
    observer.disconnect();

    setTimeout(() => {
      if (
        tab.isConnected &&
        tab.getAttribute('aria-expanded') === 'false'
      ) {
        tab.click();
      }
    }, 200);

    return true;
  }

  if (!abrir()) {
    observer.observe(root, {
      childList: true,
      subtree: true
    });

    setTimeout(() => observer.disconnect(), 15000);
  }
}

document.querySelectorAll('.lote-sorpresa')
  .forEach(abrirDescripcionLote);

document.addEventListener('shopify:section:load', event => {
  event.target.querySelectorAll('.lote-sorpresa')
    .forEach(abrirDescripcionLote);
});
function initLote(root){
 if(root.dataset.ready)return;root.dataset.ready='1';
 const cfg=JSON.parse(root.querySelector('.lote-config').textContent),form=root.querySelector('form'),lot=root.querySelector('.lote-count'),rows=root.querySelector('.lote-rows'),button=root.querySelector('.lote-add');
 const choices=Array.from({length:20},()=>({cut:'',size:''}));
 const money=n=>'$'+new Intl.NumberFormat('es-MX',{minimumFractionDigits:2,maximumFractionDigits:2}).format(n/100)+' '+(cfg.currency||'MXN');
 function update(){
  const n=Number(lot.value),xxl=choices.slice(0,n).filter(c=>c.cut==='CABALLERO'&&c.size==='XXL').length;
  const variant=cfg.variants.find(v=>v.option1===n+' playeras'&&v.option2===String(xxl));
  root.querySelector('.lote-variant').value=variant?variant.id:'';
  button.disabled=!variant||!variant.available;
  root.querySelector('.lote-price').textContent=variant?money(variant.price):cfg.labels.unavailable;
  const summary=root.querySelector('.lote-summary');summary.replaceChildren();
  for(const [label,value,cls] of [[cfg.labels.extra+' ('+xxl+')',money(xxl*4900),'lote-extra-line'],[cfg.labels.total,variant?money(variant.price):'—','lote-total-line']]){const line=document.createElement('div');line.className=cls;const title=document.createElement('span');title.textContent=label+': ';const amount=document.createElement('strong');amount.textContent=value;line.append(title,amount);summary.append(line);}
 }
 function render(){
  rows.replaceChildren();
  for(let i=0;i<Number(lot.value);i++){
   const row=document.createElement('div');row.className='lote-row';
   const number=document.createElement('span');number.textContent=i+1;row.append(number);
   const makeSelect=(label,cls)=>{
    const wrap=document.createElement('label');
    const select=document.createElement('select');select.className=cls;select.required=true;
    select.setAttribute('aria-label',label+' '+(i+1));wrap.append(select);row.append(wrap);return select;
   };
   const cut=makeSelect(cfg.labels.cut,'lote-cut'),size=makeSelect(cfg.labels.size,'lote-size');
   function options(select,values,label){select.replaceChildren(new Option(label,''),...values.map(v=>new Option(v,v)));}
   options(cut,['CABALLERO','DAMA','NIÑO'],cfg.labels.cut);cut.value=choices[i].cut;
   const prop=document.createElement('input');prop.type='hidden';prop.name='properties['+cfg.labels.shirt+' '+String(i+1).padStart(2,'0')+']';row.append(prop);
   function sizes(){if(cut.value!=='CABALLERO'&&choices[i].size==='XXL')choices[i].size='';options(size,['CH','M','L','XL',...(cut.value==='CABALLERO'?['XXL']:[])],cfg.labels.size);size.value=choices[i].size;}
   function property(){prop.value=cut.value+' · '+size.value;}
   sizes();property();
   cut.addEventListener('change',()=>{choices[i].cut=cut.value;sizes();property();update();});
   size.addEventListener('change',()=>{choices[i].size=size.value;property();update();});
   rows.append(row);
  }
  update();
 }
 lot.addEventListener('change',render);
 let submitting = false;
 const errors = document.createElement('p');
 errors.setAttribute('role', 'alert');
 errors.hidden = true;
 button.before(errors);
 form.addEventListener('submit', async event => {
  if (submitting) { event.preventDefault(); return; }
  update();
  if (!form.reportValidity() || button.disabled) { event.preventDefault(); return; }
  const drawer = document.querySelector('[data-drawer="drawer-cart"]');
  if (!drawer || document.querySelector('[data-ajax-disable]')) return;
  event.preventDefault();
  submitting = true;
  button.disabled = true;
  errors.hidden = true;
  try {
   const route = window.theme.routes.cart;
   const response = await fetch(route + '/add.js', {
    method: 'POST', body: new FormData(form),
    headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
   });
   const variant = await response.json();
   if (!response.ok) throw new Error(variant.description || 'No pudimos agregar el lote. Intenta de nuevo.');
   drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { detail: { variant, reinit: true }, bubbles: true }));
   fetch(route + '.js').then(r => r.json()).then(cart => document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart }, bubbles: true }))).catch(() => {});
  } catch (error) {
   errors.textContent = error.message;
   errors.hidden = false;
  } finally {
   submitting = false;
   update();
  }
 });
 render();
}
document.querySelectorAll('.lote-sorpresa').forEach(initLote);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.lote-sorpresa').forEach(initLote));

  } catch(e) { console.error(e); }
})();
})();
